import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Hanno gestito il rifacimento completo della facciata del nostro condominio. Tempi rispettati, cantiere pulito e nessuna sorpresa in fattura. Squadra molto professionale.",
    author: "Avv. Marco Bellini",
    role: "Amministratore condominiale · Pavia",
  },
  {
    quote:
      "Ristrutturazione chiavi in mano del nostro appartamento a Milano. Dalla demolizione al microcemento finale: un solo interlocutore, qualità impeccabile.",
    author: "Famiglia Riva",
    role: "Cliente residenziale · Milano",
  },
  {
    quote:
      "Abbiamo commissionato cancello carrabile e ringhiere su disegno. La carpenteria interna fa davvero la differenza: dettagli e tempi che nessun altro garantiva.",
    author: "Studio Conti & Partners",
    role: "Cliente B2B · Vigevano",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#0A1120] py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-px bg-[#FF5A1F]" />
          <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A1F] font-bold">
            Testimonianze
          </span>
        </div>
        <h2 className="headline text-white text-4xl md:text-6xl mb-16 max-w-4xl">
          Le parole di chi{" "}
          <span className="font-display italic font-medium text-slate-300">
            ci ha scelto.
          </span>
        </h2>

        <div className="grid md:grid-cols-3 gap-px bg-[#1E293B]">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0A1120] p-8 md:p-10 flex flex-col"
            >
              <Quote size={36} className="text-[#FF5A1F] mb-6" />
              <p className="font-display italic text-xl md:text-2xl text-white leading-snug flex-1">
                "{t.quote}"
              </p>
              <div className="mt-8 pt-6 border-t border-slate-800">
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star
                      key={k}
                      size={14}
                      className="text-[#D4AF37] fill-[#D4AF37]"
                    />
                  ))}
                </div>
                <div className="font-bold text-white text-base">{t.author}</div>
                <div className="text-xs tracking-wider uppercase text-slate-500 mt-1">
                  {t.role}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
